import { createFileRoute } from '@tanstack/react-router'

import { EditExpensePage } from '@/pages/expenses/[id]/edit/EditExpensePage'

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/$id/edit/')({
  component: EditExpensePage,
})
